import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { OBOrder } from '../../@type/order';
import { getErrorMessage } from '@/utils/stringHelper';

// ----------------------------------------------------------------------

type OrderState = {
  isLoading: boolean;
  error: boolean;
  orderList: OBOrder[];
};

const initialState: OrderState = {
  isLoading: false,
  error: false,
  orderList: []
};

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state: OrderState) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state: OrderState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = Boolean(action.payload);
    },

    getOrdersSuccess(state: OrderState, action: PayloadAction<OBOrder[]>) {
      state.isLoading = false;
      state.orderList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
export const { getOrdersSuccess } = slice.actions;

// Actions

// ----------------------------------------------------------------------

export function getOrderList(): () => Promise<void> {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/order/all');
      dispatch(slice.actions.getOrdersSuccess(response.data.orders));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(slice.actions.hasError(errorMessage));
    }
  };
}
